import {DATE_FORMAT, FaceDiagnosis, InitFaceDiagnosis} from "../../common";
import type {CascaderProps, GetProp} from 'antd';
import {Button, Cascader, Col, DatePicker, Divider, Input, InputNumber, Row, Select} from "antd";
import React, {useRef} from "react";
import {formatDateStrInput, GenerateAdministrativeDivisionsCascaderOptions, Option} from "../common";
import "./index.css"
import {FaceDiagnosisFileDownLoad} from "../../../../Http/request";
import {SUBMIT_TYPE} from "../../../../Http/common";

type DefaultOptionType = GetProp<CascaderProps, 'options'>[number];

interface P {
    defaultValue: FaceDiagnosis, // 初始化的值
    newValue?: FaceDiagnosis, // 新传入的值
    fatherChange(newValue: FaceDiagnosis): void
    saveDraft(newDraft: FaceDiagnosis |undefined, saveType: SUBMIT_TYPE): void
}

const { TextArea } = Input;

/**
 * 面诊记录单
 */
export default function ({defaultValue, newValue, fatherChange, saveDraft}: P) {
    // 当前模块的值
    const moduleValue = useRef<FaceDiagnosis | undefined>(defaultValue);

    /**
     * 更新模块中的某个值
     */
    const partChange = (newValue: Partial<FaceDiagnosis>): void => {
        let newModuleValue: FaceDiagnosis;
        if (moduleValue.current === undefined) {
            newModuleValue = InitFaceDiagnosis(defaultValue);
            moduleValue.current = newModuleValue;
        }
        newModuleValue = {
            ...moduleValue.current,
            ...newValue,
        }
        moduleValue.current = newModuleValue;
        fatherChange(newModuleValue);
    };

    /**
     * 省市区三级联动级联选择器
     */
    const administrativeDivisionsCascaderOptions: Option[] = GenerateAdministrativeDivisionsCascaderOptions();

    /**
     * 级联选择器三级联动搜索
     * @param inputValue
     * @param path
     */
    const filter = (inputValue: string, path: DefaultOptionType[]) =>
        path.some(
            (option) => (option.label as string).toLowerCase().indexOf(inputValue.toLowerCase()) > -1,
        );

    return (
        <>
            <Row justify="start"
                 align="middle"
                 className={"custom-line-row"}
                 style={{
                     marginTop: "10px",
                     marginBottom: "10px"
                 }}
            >
                <Col span={2}>
                    姓名
                </Col>
                <Col span={3}>
                    <Input
                        defaultValue={defaultValue.name}
                        onChange={(e) => {
                            partChange({name: e.target.value})
                        }}
                    />
                </Col>
                <Col span={2}>
                    性别
                </Col>
                <Col span={2}>
                    <Select
                        style={{
                            width: "100%"
                        }}
                        defaultValue={defaultValue.gender}
                        onChange={(value: string) => {
                            partChange({gender: value})
                        }}
                        options={[
                            {value: "男", label:"男"},
                            {value: "女", label: "女"}
                        ]}
                    />
                </Col>
                <Col span={2}>
                    年龄
                </Col>
                <Col span={2}>
                    <InputNumber
                        changeOnWheel
                        style={{
                            width: "100%"
                        }}
                        defaultValue={defaultValue.age}
                        onChange={(e:number | null) => {
                            partChange({age: e === null ? undefined : e})
                        }}
                        addonAfter={"岁"}
                    />
                </Col>
                <Col span={2}>
                    电话
                </Col>
                <Col span={3}>
                    <Input
                        defaultValue={defaultValue.telephoneNum}
                        onChange={(e) => {
                            partChange({telephoneNum: e.target.value});
                        }}
                    />
                        </Col>
            </Row>
            <Row justify="start"
                 align="middle"
                 className="custom-line-row"
            >
                <Col span={2}>
                    来源
                </Col>
                <Col span={2}>
                    <Input
                        defaultValue={defaultValue.source}
                        onChange={(e) => {
                            partChange({source: e.target.value})
                        }}
                    />
                </Col>
                <Col span={2}>
                    地区
                </Col>
                <Col span={6}>
                    <Cascader style={{ width: '100%' }}
                        options={administrativeDivisionsCascaderOptions}
                        defaultValue={[defaultValue.province || '', defaultValue.city || '', defaultValue.district || '']}
                        onChange={value => {
                            partChange({
                                province: String(value[0]),
                                city: String(value[1]),
                                district: String(value[2])
                            })
                        }}
                         showSearch={{filter}}
                    />
                </Col>
            </Row>
            <Row justify="start"
                 align="middle"
                 className={"custom-line-row"}
            >
                <Col span={2}>
                    疤痕部位
                </Col>
                <Col span={2}>
                    <Input
                        defaultValue={defaultValue.scarArea}
                        onChange={(e) => {
                            partChange({scarArea: e.target.value})
                        }}
                    />
                </Col>
                <Col span={2}>
                    长
                </Col>
                <Col span={3}>
                    <Input
                        defaultValue={defaultValue.scarLong}
                        onChange={(e) => {
                            partChange({scarLong: e.target.value})
                        }}
                    />
                </Col>
                <Col span={2}>
                    宽
                </Col>
                <Col span={3}>
                    <Input
                        defaultValue={defaultValue.scarWidth}
                        onChange={(e) => {
                            partChange({scarWidth: e.target.value})
                        }}
                    />
                </Col>
                <Col span={2}>
                    形状
                </Col>
                <Col span={3}>
                    <Input
                        defaultValue={defaultValue.scarShape}
                        onChange={(e) => {
                            partChange({scarShape: e.target.value})
                        }}
                    />
                </Col>
            </Row>
            <Row justify="start"
                 align="middle"
                 className={"custom-line-row"}
            >
                <Col span={2}>
                    面诊方案
                </Col>
                <Col span={22}>
                    <Input
                        defaultValue={defaultValue.faceDiagnosisPlan}
                        onChange={(e) => {
                            partChange({faceDiagnosisPlan: e.target.value})
                        }}
                    />
                </Col>
            </Row>
            <Row justify="start"
                 align="middle"
                 className={"custom-line-row"}
            >
                <Col span={2}>
                    面诊费用
                </Col>
                <Col span={22}>
                    <TextArea
                        defaultValue={defaultValue.faceDiagnosisCost}
                        onChange={(e) => {
                            partChange({faceDiagnosisCost: e.target.value})
                        }}
                        rows={2}
                    />
                </Col>
            </Row>
            <Row justify="start"
                 align="middle"
                 className={"custom-line-row"}
            >
                <Col span={2}>
                    时间
                </Col>
                <Col span={4}>
                    <DatePicker
                        style={{width:"100%"}}
                        showTime={{ format: 'HH:mm' }}
                        defaultValue={formatDateStrInput(moduleValue.current?.recordTimeStr, DATE_FORMAT)}
                        onChange={(value, dateStr: string | string[]) => {
                            if (typeof dateStr === 'string') {
                                partChange({recordTimeStr: dateStr})
                            } else {
                                partChange({recordTimeStr: dateStr[0]})
                            }
                        }}
                    />
                </Col>

            </Row>
            <Row
                justify="start"
                align="middle"
                style={{
                    marginTop: "10px",
                    marginBottom: "10px"
                }}
            >
                <Divider>下载&保存</Divider>
                <Col span={4}>
                    <Button
                        type={"link"}
                        onClick={() => {
                            if (moduleValue.current == undefined) {
                                return
                            } else {
                                FaceDiagnosisFileDownLoad(moduleValue.current);
                                saveDraft(moduleValue.current, SUBMIT_TYPE.TYPE_SAVE_DRAFT);
                            }
                        }}>
                        下载疤痕面诊单
                    </Button>
                </Col>
                <Col span={4}>
                    <Button
                        type={"primary"}
                        onClick={() => {
                            if (moduleValue.current == undefined) {
                                return
                            } else {
                                saveDraft(moduleValue.current, SUBMIT_TYPE.TYPE_SAVE_DRAFT)
                            }
                        }}
                    >
                        保存疤痕面诊单
                    </Button>
                </Col>
            </Row>
        </>
    )
}